import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';
import type { Badge } from '../bff-api/products/model/Badge';

export interface BadgeVisibilityProps extends Badge {
    pageType: 'PDP' | 'PLP';
}

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);

export const checkBadgeVisibility = ({
    badgeEndDate,
    badgeStartDate,
    badgeLabel,
    badgeShowOnPDP,
    badgeShowOnPLP,
    pageType,
}: BadgeVisibilityProps): boolean => {
    const now = dayjs().utcOffset(0).startOf('day');

    if (badgeStartDate && dayjs(badgeStartDate).utc().isAfter(now)) {
        return false;
    }

    if (badgeEndDate && dayjs(badgeEndDate).utc().isBefore(now)) {
        return false;
    }

    const visibleType =
        (badgeShowOnPDP && pageType === 'PDP') || (badgeShowOnPLP && pageType === 'PLP');

    return !!badgeLabel && !!visibleType;
};
